import { PlusOutlined,PlayCircleFilled,MinusOutlined,MessageOutlined,DownOutlined,UpOutlined } from '@ant-design/icons-vue';



  // 导入 Vue 和其他依赖
  import { createApp } from 'vue';
  import App from './App.vue';
  import router from './router';
  import { Input,Space,Row,Button,Col,Tag,Radio,Tabs,InputNumber,Modal   } from 'ant-design-vue';
  // 创建 Vue 应用
  const app = createApp(App);
  app.use(Input);
  app.use(Space);
  app.use(Row);
  app.use(Button);
  app.use(Col);
  app.use(Tag);
  app.use(Radio);
  app.use(Tabs);
  app.use(Tabs.TabPane);
  app.use(InputNumber);
  app.use(Modal);
  // 使用路由
  app.use(router);
  app.component('PlusOutlined', PlusOutlined);
  app.component('MinusOutlined', MinusOutlined);
  app.component('PlayCircleFilled', PlayCircleFilled);
  app.component('MessageOutlined', MessageOutlined);
  app.component('DownOutlined', DownOutlined);
  app.component('UpOutlined', UpOutlined);


 
  
  // 挂载应用
  app.mount('#app');
 